/**
 * Admin Auth Repository
 * 관리자 인증 데이터 액세스 계층
 */

import axios from 'axios';
import { API_BASE_URL } from '../../../config/api';
import {
  AdminUser,
  AdminLoginRequest,
  AdminLoginResponse,
  AdminProfileUpdateRequest,
  AdminPasswordChangeRequest,
  CreateOperatorRequest,
} from '../models';

// Alias for backward compatibility
type UpdateProfileRequest = AdminProfileUpdateRequest;

export class AdminAuthRepository {
  private baseUrl = `${API_BASE_URL}/admin/auth`;

  private getAuthHeaders() {
    const token = localStorage.getItem('admin_token');
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  async login(request: AdminLoginRequest): Promise<AdminLoginResponse> {
    const response = await axios.post(`${this.baseUrl}/login`, {
      email: request.email,
      password: request.password,
    });

    // role이 admin 또는 operator인지 확인
    const user = response.data.user;
    if (user.role !== 'admin' && user.role !== 'operator') {
      throw new Error('관리자 권한이 없습니다.');
    }

    return response.data;
  }

  async logout(): Promise<void> {
    await axios.post(
      `${this.baseUrl}/logout`,
      {},
      { headers: this.getAuthHeaders() }
    );
  }

  async getProfile(): Promise<AdminUser> {
    const response = await axios.get(`${this.baseUrl}/profile`, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async updateProfile(request: AdminProfileUpdateRequest): Promise<AdminUser> {
    const response = await axios.put(`${this.baseUrl}/profile`, request, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }

  async changePassword(request: AdminPasswordChangeRequest): Promise<void> {
    await axios.post(`${this.baseUrl}/change-password`, request, {
      headers: this.getAuthHeaders(),
    });
  }

  async createOperator(request: CreateOperatorRequest): Promise<AdminUser> {
    const response = await axios.post(`${this.baseUrl}/operators`, request, {
      headers: this.getAuthHeaders(),
    });
    return response.data;
  }
}
